<tg-mobile-full-screen-dialog [fixedHeader]="true">
  <h1 class="title" i18n="Post views stats dialog|title @@postViewsStatsDialog.title">
    Статистика просмотров поста
  </h1>
  <tg-inline-loader *ngIf="loading"></tg-inline-loader>
  <div #container [class.full]="full.useFullScreen"></div>
</tg-mobile-full-screen-dialog>
